import { SublocalityComponent } from './sublocality/sublocality.component';
//@angular components
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//Components
import { AppComponent } from './app.component';

import { NotFoundComponent } from './not-found/not-found.component';
// import { OrginalEnddatebasedReportComponent} from './orginal-enddatebased-report/orginal-enddatebased-report.component'


//mycomps

import { DashboardComponent } from './dashboard/dashboard.component';
import { ThreeTimeOrMorePostponementReportComponent } from './three-time-or-more-postponement-report/three-time-or-more-postponement-report.component';
import { ServiceDueReportComponent } from './service-due-report/service-due-report.component';
import { StatusReportOneMonthBeforeComponent } from './status-report-one-month-before/status-report-one-month-before.component';
import { InactiveCustomerReportComponent } from './inactive-customer-report/inactive-customer-report.component';
import { CustomerContractReportComponent } from './customer-active-inactive-report/customer-active-inactive-report.component';
import { CustomerMachineSummaryReportComponent } from './customer-machine-summary-report/customer-machine-summary-report.component';
import { CustomerNoContractReportComponent } from './customer-no-contract-report/customer-no-contract-report.component';
import { CheckListMasterComponent } from './check-list-master/check-list-master.component';
import { MyformComponent } from './myform/myform.component';
import { CustomerMasterComponent } from './customer-master/customer-master.component';
import { CheckListDetailsComponent } from './check-list-details/check-list-details.component';
import { PreventiveMaintenanceComponent } from './preventive-maintenance/preventive-maintenance.component';
import { ServiceContractComponent } from './service-contract/service-contract.component';
import { PostPonedFormComponent } from './postPoned-form/postPoned-form.component';
import { CalenderComponent } from './calender/calender.component';
//services
// import { AuthGuardLogin } from './services/auth-guard-login.service';
// import { AuthGuardAdmin } from './services/auth-guard-admin.service';
import { MakeComponent } from './make/make.component';
import { ModelComponent } from './model/model.component';
import { LabourCostComponent } from './labour-cost/labour-cost.component';
import { ServiceTypeComponent } from './service-type/service-type.component';
import { HistoryComponent } from './history/history.component';
import { BranchComponent } from './branch/branch.component';
import { DescriptionComponent } from './description/description.component';
import { EmiratesComponent } from './emirates/emirates.component';
import { PartdetailsComponent } from './partdetails/partdetails.component';
import { TravelcostComponent } from './travelcost/travelcost.component';
import { LoopComponent } from './loop/loop.component';
import {ServiceEndDateComponent} from './service-end-date/service-end-date.component';
import {PmaCategoryComponent } from './pma-category/pma-category.component';
import { InvoiceReportComponent } from './invoice-report/invoice-report.component';
// import { VirComponent } from './vir/vir.component';
// import { AddMailComponent } from './add-mail/add-mail.component';
/**

STEPS EXPLAINED AT server/routes.ts

INSTRUCTIONS :

define routes in Routes below.
DO NOT USE / in PATH ! However you DO so in redirectTo
use canActivate:['<service>'] to enable services upon launch

redirections are initiated in  the respective components

For Server side processing refer server/routes.ts
**/
const routes: Routes = [
  //{ path: '', component: FormBuilderComponent },

  { path: 'node/notfound', component: NotFoundComponent },
  // { path: 'node/checkListMaster', component: CheckListMasterComponent },
  { path: 'node/customerMaster', component: CustomerMasterComponent },
  // { path: 'node/checkListDetails', component: CheckListDetailsComponent },
  { path: 'node/preventiveMaintenance', component: PreventiveMaintenanceComponent },
  { path: 'node/serviceContract', component: ServiceContractComponent },
  { path: 'node/postPonedForm', component: PostPonedFormComponent },
  { path: 'node/myform', component: MyformComponent },
  { path: 'node/dashboard',component:DashboardComponent},
  { path: 'node/ThreeTimeOrMorePostponementReport',component:ThreeTimeOrMorePostponementReportComponent},
  { path: 'node/ServiceDueReport',component:ServiceDueReportComponent},
  { path: 'node/StatusReportOneMonthBefore',component:StatusReportOneMonthBeforeComponent},
  { path: 'node/InactiveCustomerReport',component:InactiveCustomerReportComponent},
  { path: 'node/CustomerContractReport',component:CustomerContractReportComponent},
  { path: 'node/CustomerActiveInactiveReport',component:CustomerContractReportComponent},
  { path: 'node/CustomerMachineSummaryReport',component:CustomerMachineSummaryReportComponent},
  { path: 'node/CustomerNoContractReport',component:CustomerNoContractReportComponent},
  { path: 'node/calendar',component:CalenderComponent},
  { path: 'node/make',component:MakeComponent},
  { path: 'node/model',component:ModelComponent},
  { path: 'node/labourCost',component:LabourCostComponent},
  { path: 'node/serviceType',component:ServiceTypeComponent},
  { path: 'node/history',component:HistoryComponent},
  { path: 'node/branch', component:BranchComponent},
  { path: 'node/description', component:DescriptionComponent},
  { path: 'node/emirates', component:EmiratesComponent},
  { path: 'node/partdetails', component:PartdetailsComponent},
  { path: 'node/travelcost',component:TravelcostComponent},
  { path: 'node/sublocality',component:SublocalityComponent},
  { path: 'node/loop', component:LoopComponent},
  {path:  'node/pmaCategory',component:PmaCategoryComponent},
  { path: 'node/invoice-report',component:InvoiceReportComponent},
  {path:  'node/orginalEndDateReport',component:ServiceEndDateComponent}
  // {path:  'node/vir',component:VirComponent},
  // {path:  'node/add-mail',component:AddMailComponent}
  // { path: '**', redirectTo: 'node/make' },

];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})

export class RoutingModule {}



// WEBPACK FOOTER //
// ./client/app/routing.module.ts